import { AnyAction } from 'redux'
import * as React from 'react'
import { ISearchLoadingFailed } from '../../actions/search/loadSearch'
import { AuthorizationActions } from '../userAccount/actionNames'
import { SearchActions } from './actionNames'
import initialStore from './initialState'
import searchIsLoading from './mutators/searchIsLoading'
import searchIsReady from './mutators/searchIsReady'
import searchLoadingFailed from './mutators/searchLoadingFailed'
import setDrawerRef from './mutators/setDrawerRef'

export default function(
  store: Readonly<ISearchStore> = initialStore,
  action: AnyAction,
): ISearchStore {
  switch (action.type) {
    case SearchActions.LoadSearch:
      return searchIsLoading(store)
    case SearchActions.SearchIsReady:
      return searchIsReady(store)
    case SearchActions.SearchLoadingFailed:
      return searchLoadingFailed(store, action as ISearchLoadingFailed)
    case 'Set drawer ref':
      return setDrawerRef(store, action)
    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }
  return store
}

export interface ISearchStore {
  isLoading: boolean
  isReady: boolean
  errMessage: string
  drawerRef?: React.RefObject<HTMLDivElement>
}
